import {MatStepperModule} from '@angular/material/stepper';
import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {ServicesModule} from './core/modules/services.module';
import {OAuthModule, OAuthStorage} from "angular-oauth2-oidc";
import {AuthComponent} from "./core/auth/auth.component";
import {TokenInterceptor} from "./core/auth/token.interceptor";
import {LogoutComponent} from "./core/auth/logout.component";
import {GtagModule} from "angular-gtag";
import {AuthGuard} from './core/auth/auth-guard';
import {CookieStorage} from 'cookie-storage';

@NgModule({
  declarations: [
    AppComponent,
    AuthComponent,
    LogoutComponent
  ],
  imports: [
    OAuthModule.forRoot(),
    BrowserModule,
    AppRoutingModule,
    NgbModule,
    HttpClientModule,
    MatStepperModule,
    BrowserAnimationsModule,
    ServicesModule,
    GtagModule.forRoot({ trackingId: 'UA-116843639-2', trackPageviews: true })
  ],
  providers: [
     {
       provide: HTTP_INTERCEPTORS,
       useClass: TokenInterceptor,
       multi: true
     },
    {
      provide: OAuthStorage,
      useValue: new CookieStorage()
    },
    AuthGuard
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
